import { createSlice } from "@reduxjs/toolkit";

//these are the initial states of the movie we wanna store
const initialState = {
    watchLaterList: [],
};

//once we get the movie from the database we will create a slice and store it

const watchLaterSlice = createSlice({
    name: 'watchLater',
    initialState,
    reducers: {
        setAddMovie: (state, action) => {
            state.watchLaterList = [...state.watchLaterList, {...action.payload.movieDetails}]
        } ,

        setPerserveList: (state, action) => {
        state.watchLaterList = action.payload.watchLaterList
    },

    setRemoveMovie: (state, action) => {
        const newList = state.watchLaterList.filter(movie => movie.doc_id != action.payload.doc_id)
        state.watchLaterList = newList
    },

    setRemoveAll: (state, action) => {
        state.watchLaterList = action.payload.movie
    },
}
    
});

export const { setAddMovie, setPerserveList, setRemoveMovie, setRemoveAll} = watchLaterSlice.actions

export const selectWatchLaterList = state => state.watchLater.watchLaterList;


export default watchLaterSlice.reducer;